import PropTypes from 'prop-types';

const giftTablePropTypes = {
  dispatch: PropTypes.func,
  withRecommendations: PropTypes.bool,
  tableInfo: PropTypes.shape({
    recommendation_type: PropTypes.number,
    welcome_message: PropTypes.string,
    type: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    guest_range: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  }),
  addGifts: PropTypes.bool,
  externalLink: PropTypes.bool,
  values: PropTypes.shape({
    selectedCategory: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    filterCategory: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  setFieldValue: PropTypes.func,
  dynamicRecommendations: PropTypes.arrayOf(
    PropTypes.shape({
      category_sears_id: PropTypes.number
    })
  ),
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      category_sears_id: PropTypes.number
    })
  ),
  showFilterByOrder: PropTypes.bool,

  addProduct: PropTypes.func,
  changeGiftTableProductsPage: PropTypes.func,
  changeGiftTableProductsSort: PropTypes.func,
  changeRecommendationProductsOrder: PropTypes.func,
  deleteProduct: PropTypes.func,
  fetchDynamicConfiguration: PropTypes.func,
  fetchProductsOfDynamicCategory: PropTypes.func,
  fetchGiftTableProducts: PropTypes.func,
  fetchProductsOfSelectedCategory: PropTypes.func,
  fetchProductsByRecommendations: PropTypes.func,
  fetchAllProductsOfRecommendations: PropTypes.func,
  fetchGiftsByFilters: PropTypes.func,
  fetchGiftTableInfo: PropTypes.func,
  resetGiftsProducts: PropTypes.func,
  setGiftsProductsParams: PropTypes.func,
  setShowRecommendations: PropTypes.func,
  cleanGiftsProductsParams: PropTypes.func
};

export default giftTablePropTypes;
